/* eslint-disable */
import { AccordionBtn } from "./accordion-btn.component";
import { LinkMenu } from "./link-menu.component";
import { PowerSettingsNewIcon } from "../icons";
import { useAuth, useCurrentUserRole } from "../../hooks";
import "../layout.css";

export function Sidebar() {
  const { signOutUser } = useAuth();
  const nikuLogo = "https://niku.com.mx/public/images/imgForApp/egynatens.png";
  const { isAccountant } = useCurrentUserRole();
  return (
    <div className="sidebar">
      <div className="sidebar-item-top">
        <img alt="niku-logo" className="sidebar-img" src={nikuLogo} />
      </div>
      {isAccountant ? (
        <AccordionBtn text="Niku Car">
          <LinkMenu pathname="/ListDrivers" title="Conductores" />
          {/*           <LinkMenu pathname="/ListHistoryDriver" title="Historial" /> */}
        </AccordionBtn>
      ) : (
        <>
          <AccordionBtn text="Negocios">
            <LinkMenu pathname="/ListShops" title="Tiendas" />
          </AccordionBtn>

          <AccordionBtn text="Repartidores">
            <LinkMenu pathname="/ListDelivery" title="Repartidores" />
          </AccordionBtn>
          <AccordionBtn text="Niku Car">
            <LinkMenu pathname="/ListDrivers" title="Conductores" />
            {/*          <LinkMenu pathname="/ListHistoryDriver" title="Historial" /> */}
          </AccordionBtn>
        </>
      )}

      <div className="sidebar-item-bottom">
        <p
          style={{
            fontSize: "0.8rem",
            position: "absolute",
            bottom: 0,
            right: 10,
          }}
        >
          Versión de sistema 1.0.2
        </p>
        <button
          className="sidebar-btn-logout"
          type="button"
          onClick={signOutUser}
        >
          <PowerSettingsNewIcon />
          <p className="sidebar-btn-lbl">Cerrar sesión</p>
        </button>
      </div>
    </div>
  );
}
